module.exports = __webpack_public_path__ + "img/1.b06b13d2.png";